import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import TriggerApiOnView from './TriggerApiOnView'
import { useEffect, useState } from 'react'
import { getCachevalue } from '../../../../Utility/Services/CacheProviderService'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions'
import { ImagePaths } from '../../../../Utility/ImagePaths'
import { Other_Doctor_Notes_Layout_JSON } from '../../../../Utility/Constants'
import { DateTime } from 'luxon';

const doctorNote = {
    symptoms: [],
    patientCate: [],
    vitals: [],
    allergys: [],
    examination: [],
    diagnosis: [],
    provisionalDiagnosis: "",
    prescription: [],
    plan: [],
    genadvice: '',
    counselling: {},
    reviewPlan: {},
    complaints: [],
    IP_symptom: [],
    IP_examination: [],
    IP_proviDig: [],
    IP_Dignosis: [],
    IP_notes: [],
    entChartNote: '',
    ENTImage: '',
    clinicalHis: {},
    painChart: [],
    pastHis: [],
    finalDig: [],
    obstric: {},
    history_of_presenting_illness: [],
    Gen_examination: [],
}
export default function CollabDocNotes(props) {
    const [patient_id, setpatient_id] = useState(null)
    const [docNotes, setdocNotes] = useState(doctorNote);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [clinicID, setclinicID] = useState(null);
    const [notesLayout, setnotesLayout] = useState({});
    const [isNewOtherDoc, setIsNewOtherDoc] = useState(false);

    useEffect(() => {
        try {
            getNotesLayoutData();
            const cachedData = getCachevalue('DoctorPatientData');
            const appointData = JSON.parse(cachedData);
            const clinicId = getCachevalue('SelectedDoctorClinic')
            const is_new_other = JSON.parse(localStorage.getItem("loggedInUserInfo"))?.new_doctor_notes_template_others ? true : false;
            setIsNewOtherDoc(is_new_other);
            if (appointData?.patient_id) {
                setpatient_id(appointData.patient_id);
            }
            if (clinicId) {
                setclinicID(clinicId)
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }, []);

    const getNotesLayoutData = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_LAYOUT + `?doctor_id=${doctorID}&is_collabrative=true`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setnotesLayout(
                            Array.isArray(response.data.data) && response.data.data.length > 0
                                ? response.data.data
                                : typeof response.data.data === 'object' && Object.keys(response.data.data).length > 0
                                    ? response.data.data
                                    : {
                                        field_data: {
                                            left_data: Other_Doctor_Notes_Layout_JSON
                                        }
                                    }
                        );
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    }
                    else {
                        errorMessage(error.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
    }
    const errorMessage = (msg) => {
        seterrorMsg(true)
        seterrorMsgText(msg)
    }

    const fetchData = (url, query, handleResponse) => {
        RestAPIService[url === "DOC_OBSTETRIC_DATA_GET" ? "GetWithoutReplica" : "getAll"](`${Serviceurls[url]}${query}`)
            .then((response) => {
                if (response.data.status === 'success') {
                    handleResponse(response.data.data);
                }
            }).catch((error) => {
                if (error?.response?.data?.message) {
                    errorMessage(error.response.data.message)
                } else {
                    errorMessage(error.message)
                }
            })
    }

    const fetchDataTwo = (url, query, handleResponse) => {
        RestAPIService.getAllTwo(`${Serviceurls[url]}${query}`)
            .then((response) => {
                if (response.data.status === 'success') {
                    handleResponse(response.data.data);
                }
            }).catch((error) => {
                if (error?.response?.data?.message) {
                    errorMessage(error.response.data.message)
                } else {
                    errorMessage(error.message)
                }
            })
    }

    const { id, isProgrammaticScroll, userData, details, roleType, doctorID } = props;

    const getNoteData = (section, name) => {
        const idKey = details?.visit_type !== "OP" ? "ip_admission_id=" + details?.admission_id : "appointment_id=" + details?.appointment_id;
        const query = section === 'counselling' ? `?patient_id=${patient_id}&${idKey}&clinic_id=${clinicID}` : `?patient_id=${patient_id}&${idKey}`;
        switch (section) {
            case "symptoms":
                fetchData(
                    isNewOtherDoc ? "SARAS_DOC_SYMPTOMS" : "DOC_DOCTOR_NOTES_SYMPTOMS",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            symptoms: isNewOtherDoc ? data?.symptoms || "" : data || [],
                        }));
                    }
                );
                break;
            case "patientCategory":
                fetchData(
                    isNewOtherDoc ? "SARAS_DOC_PATIENT_CATEGORY_GET" : "DOC_DOCTOR_NOTES_PATIENT_CATEGORY",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            patientCate: data || [],
                        }));
                    }
                );
                break;
            case "vitals":
                fetchData(
                    isNewOtherDoc ? "SARAS_DOC_VITALS" : "DOC_DOCTOR_NOTES_VITALS",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            vitals: isNewOtherDoc ?
                                (Object.keys(data)?.length > 0 ? [data] : [])
                                : data || [],
                        }));
                    }
                );
                break;
            case "allergy":
                fetchData(
                    "DOC_DOCTOR_NOTES_ALLERGIES",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            allergys: data || [],
                        }));
                    }
                );
                break;
            case "examination":
                fetchData(
                    isNewOtherDoc ? "SARAS_DOC_EXAMINATION_GET" : "DOC_DOCTOR_NOTES_EXAMINATION_GET",
                    `${query}&new_system=true`,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            examination: data.examinations || [],
                        }));
                    }
                );
                 fetchData(
                    "GENERAL_EXAMINATION_GET",
                    `${query}`,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            Gen_examination: data.examinations || [],
                        }));
                    }
                );
                break;
            case "diagnosis":
                if (isNewOtherDoc) {
                    fetchData(
                        "SARAS_DOC_ICD_DIAGNOSIS_GET",
                        `${query}`,
                        (data) => {
                            setdocNotes((prevData) => ({
                                ...prevData,
                                diagnosis: data || [],
                            }));
                        }
                    )
                    fetchData(
                        "SARAS_DOC_PROVDIAGNOSIS",
                        `${query}`,
                        (data) => {
                            setdocNotes((prevData) => ({
                                ...prevData,
                                provisionalDiagnosis: data?.provisional_diagnosis || "",
                            }));
                        }
                    )
                } else {
                    fetchDataTwo(
                        "DOC_DOCTOR_NOTES_ASSESSEMENT",
                        query,
                        (data) => {
                            setdocNotes((prevData) => ({
                                ...prevData,
                                provisionalDiagnosis: data?.provisional_diagnosis || "",
                                diagnosis: data.icd_codes || [],
                            }));
                        }
                    );
                }
                break;
            case "prescription":
                fetchData(
                    isNewOtherDoc ? "SARAS_DOC_PRESCRIPTION_DATA" : "DOC_DOCTOR_NOTES_PRESCRIPTION",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            prescription: data || [],
                        }));
                    }
                );
                break;
            case "plan":
                fetchData(
                    isNewOtherDoc ? "SARAS_DOC_PLAN" : "DOC_DOCTOR_NOTES_PLAN_GET",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            plan: isNewOtherDoc ? data?.plans  || "" : data || [],
                        }));
                    }
                );
                break;
            case "genralAdvice":
                fetchDataTwo(
                    isNewOtherDoc ? "SARAS_DOC_GENERALADVICE" : "DOC_DOCTOR_NOTES_ASSESSEMENT",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            genadvice: isNewOtherDoc ? data.general_advice || "" : data.advice_given || '',
                        }));
                    }
                );
                break;
            case "counselling":
                fetchData(
                    "DOC_DOCTOR_NOTES_SURGERY_DETAILS",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            counselling: data.surgery_details || {},
                        }));
                    }
                );
                break;
            case "reviewplan":
                fetchData(
                    isNewOtherDoc ? "SARAS_DOC_REVIEW_PLAN" : "DOC_OPT_REVIEW_PALN",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            reviewPlan: isNewOtherDoc ? data || {} : data.review_plan || {},
                        }));
                    }
                );
                break;
            case "complaints":
                fetchData(
                    isNewOtherDoc ? "SARAS_DOC_COMPLAINTS" : "DOC_DOCTOR_NOTES_COMPLAINTS_GET",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            complaints: isNewOtherDoc ? data?.complaints || "" : data || [],
                        }));
                    }
                );
                break;
            case "symptomsIP":
                fetchData(
                    "IP_DOCNOTES_SYMPTOMS",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            IP_symptom: data || [],
                        }));
                    }
                );
                break;
            case "examinationIP":
                fetchData(
                    "IP_DOCNOTES_EXAMINATION",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            IP_examination: data || [],
                        }));
                    }
                );
                break;
            case "proviDiagIP":
                fetchData(
                    "IP_DOCNOTES_PROVISIONAL_DIAG",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            IP_proviDig: data || [],
                        }));
                    }
                );
                break;
            case "diagnosisIP":
                fetchData(
                    "IP_DOCNOTES_DIAGNOSIS",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            IP_Dignosis: data || [],
                        }));
                    }
                );
                break;
            case "disNoteIP" || "FamilyCounIP" || "medicationIP":
                fetchData(
                    "IP_DOC_WRITE_NOTES",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            IP_notes: data || [],
                        }));
                    }
                );
                break;
            case 'entChart':
                fetchData(
                    "DOC_ENT_CLINICAL_EXAM_GET",
                    `${query}&doc_id=${doctorID}`,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            entChartNote: data?.notes || [],
                        }));
                        if (data?.clinicexam_image_key) {
                            setBackgroundImage(data?.clinicexam_image_key);
                        }

                    }
                );
                break;
            case 'clinicalHis':
                fetchData(
                    "DOC_DOCTOR_NOTES_CLINICAL_HISTORY",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            clinicalHis: data || {},
                        }));
                    }
                );
                break;
            case 'pain':
                fetchData(
                    isNewOtherDoc ? "SARAS_DOC_PAINCHART_GET" : "IP_PAIN_CHART",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            painChart: data || [],
                        }));
                    }
                );
                break;
            case 'past':
                fetchData(
                    "DOC_PAST_HISTORY_GET",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            pastHis: data.past_history || [],
                        }));
                    }
                );
                break;
            case 'finalDig':
                fetchData(
                    isNewOtherDoc ? "SARAS_DOC_FNLDIAGNOSIS" : "DOC_FINAL_DIAGNOSIS_GET",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            finalDig: isNewOtherDoc ? data?.final_diagnosis || "" : data.icd_codes || [],
                        }));
                    }
                );
                break;
            case 'obsData':
                fetchData(
                    "DOC_OBSTETRIC_DATA_GET",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            obstric: data || {},
                        }));
                    }
                );
                break;
            case "history_of_presenting_illness":
                fetchData(
                    "DOC_DOCTOR_NOTES_PRESENTINGILLNESS_GET",
                    query,
                    (data) => {
                        setdocNotes((prevData) => ({
                            ...prevData,
                            history_of_presenting_illness: data || [],
                        }));
                    }
                );
                break;
            default:
                if (details.visit_type === 'OP') {
                    fetchData(
                        isNewOtherDoc ? "SARAS_DOC_NEW_LAYOUT" : "DOC_NEW_LAYOUT_GET",
                        query,
                        (data) => {
                            setdocNotes((prevData) => ({
                                ...prevData,
                                [name]: data[name] || {},
                            }));
                        }
                    );
                }
                break;
        }
    };

    async function setBackgroundImage(doc_key) {
        try {
            const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(doc_key));
            if (response.data.status === "success") {
                const Data = response?.data;
                setdocNotes((prevData) => ({
                    ...prevData,
                    ENTImage: Data?.data,
                }));
            }
        } catch (e) {
            this.setState({
                isErrorMsg: true,
                isLoader: false,
                isErrorMsgText: "Error fetching S3 URL"
            });
        }
    }
    const renderClinicExamImage = (fromPopup = false) => {
        const screenWidth = window.innerWidth;
        const containerWidth = screenWidth >= 1440 ? "40vw" : screenWidth >= 768 ? "56vw" : "90vw";
        const sketchWidth = Math.min(screenWidth * 0.8, 570);
        const sketchHeight = (sketchWidth / 570) * 530;
        return (
            <div style={{ height: '100%', width: "100%" }}>
                <img src={docNotes.ENTImage} alt='ENT Image' style={{ width: "100%", height: "auto", objectFit: "contain" }} />
            </div>
        )
    }
    return (
        <Box marginLeft={'.5vw'} borderBottom={'1px solid #E3E2E2'} paddingBottom={"1vw"}>
            {details.visit_type === 'OP' ?
                <Box>
                    {notesLayout?.field_data?.left_data.length > 0 ? notesLayout?.field_data?.left_data.map((item) => {
                        if (item.field_name === 'clinicExam' && item.is_active) {
                            return (
                                <Box>
                                    {roleType === "ENT" ?
                                        <TriggerApiOnView id={`entChart_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                            <Box id={`entChart_${id}`} marginTop={'1vw'}>
                                                <Typography fontWeight={'bold'} fontSize={'1vw'}>Clinical Examination</Typography>
                                                <Box component={'div'} p={'0.5vw'}>
                                                    <Box component={'div'} style={{ display: "flex", justifyContent: "center", width: '100%' }}>
                                                        {renderClinicExamImage()}
                                                    </Box>
                                                </Box>
                                                <Box component={'div'} p={'0.5vw'}>
                                                    <div style={{ display: 'flex', gap: '0.5vw' }}>
                                                        <TextField
                                                            size='small'
                                                            sx={{ width: '95%' }}
                                                            inputProps={{ maxLength: 350 }}
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            multiline={true}
                                                            label={"Clinical Examination Notes"}
                                                            rows={4}
                                                            value={docNotes?.entChartNote || ''}
                                                        />
                                                    </div>
                                                </Box>
                                            </Box>
                                        </TriggerApiOnView>
                                        : null}
                                </Box>
                            )
                        }
                        else if (item.field_name === 'symptoms' && item.is_active) {
                            return (
                                <TriggerApiOnView id={`symptoms_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`symptoms_${id}`} marginTop={'1vw'}>
                                        {isNewOtherDoc ? <Box mt={'.5vw'} display={'flex'} flexDirection={'row'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontWeight={550} fontSize={'1vw'}>Symptoms</Typography>
                                                <Typography fontSize={'1vw'}>:</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} ml={'1vw'}
                                                    dangerouslySetInnerHTML={{ __html: docNotes?.symptoms || "-" }} />
                                            </Box>
                                        </Box> :
                                        <><Typography fontWeight={'bold'} fontSize={'1vw'}>Symptoms</Typography>
                                        {docNotes.symptoms.length > 0 ? docNotes.symptoms.map((item, index) => (
                                            <Box>
                                                <Typography fontSize={'.9vw'} fontWeight={'bold'} color={'#616161'}>{`Symptoms ${index + 1}`}</Typography>
                                                <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                    <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                        <Typography fontSize={'1vw'}>{`Symptom Name`}</Typography>
                                                        <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                    </Box>
                                                    <Box width={'50vw'}>
                                                        <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.symptom || '-'}</Typography>
                                                    </Box>
                                                </Box>
                                                <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                    <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                        <Typography fontSize={'1vw'}>{`Duration`}</Typography>
                                                        <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                    </Box>
                                                    <Box width={'50vw'}>
                                                        <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item?.duration ? `${item?.duration} - ${item?.duration_mode === '1' ? 'Days' : item?.duration_mode === '2' ? 'Weeks' : item?.duration_mode === '3' ? 'Months' : 'Years'}` : '-'}</Typography>
                                                    </Box>
                                                </Box>
                                                <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                    <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                        <Typography fontSize={'1vw'}>{`Comments`}</Typography>
                                                        <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                    </Box>
                                                    <Box width={'50vw'}>
                                                        <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{
                                                            item.symptom_desc.length > 80 ?
                                                                <Tooltip title={item.symptom_desc} placement='top'><Typography fontSize={'1vw'} fontWeight={'bold'}>{item.symptom_desc.slice(0, 80) + '...'}</Typography></Tooltip> : item.symptom_desc || '-'}</Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        )) : null}</>}
                                    </Box>
                                </TriggerApiOnView>
                            )
                        }
                        else if (item.field_name === 'patient_category' && item.is_active) {
                            return (
                                <Box marginTop={'1vw'}>
                                    <Typography fontWeight={'bold'} fontSize={'1vw'}>Patient Category</Typography>
                                    <TriggerApiOnView id={`patientCategory_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`patientCategory_${id}`} marginTop={'.5vw'}>
                                            {docNotes.patientCate.length > 0 ? docNotes.patientCate.map((item) => (
                                                <Box display={'flex'} marginTop={'.5vw'}>
                                                    <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                        <Typography fontSize={'1vw'}>{`Patient Category`}</Typography>
                                                        <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                    </Box>
                                                    <Box width={'50vw'}>
                                                        <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.category}</Typography>
                                                    </Box>
                                                </Box>
                                            )) : null}
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else if (item.field_name === 'vitals' && item.is_active) {
                            return (
                                <Box marginTop={'1vw'}>
                                    <TriggerApiOnView id={`vitals_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`vitals_${id}`}>
                                            <Typography fontWeight={'bold'} fontSize={'1vw'}>Vitals</Typography>
                                            {docNotes.vitals.length > 0 ? docNotes.vitals.map((item) => (
                                                <Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`Height`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{`${item.height_cm} CM`}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`Weight`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{`${item.weight_kg} Kg`}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography>{`BMI`}</Typography>
                                                            <Typography>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.bmi}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography>{`BSA`}</Typography>
                                                            <Typography>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.bsa}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography>{`Temperature`}</Typography>
                                                            <Typography>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{`${item.temperature} F`}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography>{`Puls Rate`}</Typography>
                                                            <Typography>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{`${item.pulse_rate}/min`}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography>{`BP | D>S`}</Typography>
                                                            <Typography>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{`${item.blood_pressure_systolic} | ${item.blood_pressure_diastolic} mm/Hg`}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography>{`SpO2`}</Typography>
                                                            <Typography>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{`${item.pulse_oximetry}%`}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography>{`Oxygen Source`}</Typography>
                                                            <Typography>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{`${item.oxygen_source}`}</Typography>
                                                        </Box>
                                                    </Box>
                                                    {
                                                        item.oxygen_source === "O2 (With Oxygen)" && <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                                <Typography>{`Oxygen Support`}</Typography>
                                                                <Typography>{`:`}</Typography>
                                                            </Box>
                                                            <Box width={'50vw'}>
                                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{`${item.oxygen_support} L/min`}</Typography>
                                                            </Box>
                                                        </Box>}
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography>{`Blood Glucose`}</Typography>
                                                            <Typography>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'} >{`${item.blood_sugar} mg/DL`}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography>{`Heart Rate`}</Typography>
                                                            <Typography>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'} >{`${item.heart_rate} bpm`}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography>{`Respiratory Rate`}</Typography>
                                                            <Typography>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'} >{`${item.respiratory_rate} breaths/min`}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography>{`Capillary Refill Time`}</Typography>
                                                            <Typography>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'} >{`${item.capillary_refill_time} sec`}</Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            )) : null}
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else if (item.field_name === 'allergies' && item.is_active) {
                            return (
                                <Box marginTop={'1vw'}>
                                    <TriggerApiOnView id={`allergy_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`allergy_${id}`}>                                    
                                            <Typography fontWeight={'bold'} fontSize={'1vw'}>Allergies</Typography>
                                            {docNotes.allergys.length > 0 ? docNotes.allergys.map((item, i) => (
                                                <Box>
                                                    <Typography fontSize={'.9vw'} fontWeight={'bold'} color={'#616161'}>{`Allergy ${i + 1}`}</Typography>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`Allergy Type`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.allergy_type === 3 ? `No Allergy` : item.allergy_type === 1 ? `Medication Allergy` : `Non-Medication Allergy`}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`Allergy Name`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.name || ''}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`Status`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.allergy_type === 3 ? `-` : item?.is_active ? `Active` : 'InActive'}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`Comments`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{
                                                                item.comments.length > 80 ?
                                                                    <Tooltip title={item.comments} placement='top'><Typography fontSize={'1vw'} fontWeight={'bold'}>{item.comments.slice(0, 80) + '...'}</Typography></Tooltip> : item.comments || '-'}</Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            )) : null}
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else if (item.field_name === 'examination' && item.is_active) {
                            return (
                                <Box marginTop={'1vw'}>
                                    <Typography fontWeight={'bold'} fontSize={'1vw'}>Examination</Typography>
                                    <TriggerApiOnView id={`examination_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`examination_${id}`}>
                                            {docNotes.examination.length > 0 ? docNotes.examination.map((item, i) => (
                                                <Box>
                                                    <Typography fontSize={'.9vw'} fontWeight={'bold'} color={'#616161'}>{`Systematic Examination ${i + 1}`}</Typography>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`Systematic Examination`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{ isNewOtherDoc ? item.systematic_examination || '-' :  item.group_name || '-'}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`Signs`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{isNewOtherDoc ? item.signs || '-' : item.examination_name || '-'}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`Notes`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{isNewOtherDoc ? item.comments || '-' : item.value || '-'}</Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            )) : null}
                                            {docNotes?.Gen_examination?.length > 0 ? docNotes?.Gen_examination.map((item, i) => (
                                                <Box>
                                                    <Typography fontSize={'.9vw'} fontWeight={'bold'} color={'#616161'}>{`General Examination ${i + 1}`}</Typography>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`General Examination`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{ item.group_name || '-'}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`Signs`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{ item.examination_name || '-'}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`Notes`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{ item.notes || '-'}</Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            )) : null}
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else if (item.field_name === 'diagnosis' && item.is_active) {
                            return (
                                <Box marginTop={'1vw'}>
                                    <Typography fontWeight={'bold'} fontSize={'1vw'}>Diagnosis</Typography>
                                    <TriggerApiOnView id={`diagnosis_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`diagnosis_${id}`}>
                                            {docNotes.diagnosis.length > 0 ? docNotes.diagnosis.map((item, o) => (
                                                <Box>
                                                    <Typography fontSize={'.9vw'} fontWeight={'bold'} color={'#616161'}>{`Diagnosis ${o + 1}`}</Typography>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`ICD Code`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.icd_code || '-'}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`Short Description`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.short_desc || '-'}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`Long Description`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.desc || '-'}</Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            )) : null}
                                        </Box>
                                        <Box>
                                            {docNotes?.provisionalDiagnosis && (
                                                <Box mt={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                    <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                        <Typography fontWeight={550} fontSize={'1vw'}>Provisional Diagnosis</Typography>
                                                        <Typography fontSize={'1vw'}>:</Typography>
                                                    </Box>
                                                    <Box width={'50vw'}>
                                                        <Typography fontSize={'1vw'} fontWeight={'bold'} ml={'1vw'}
                                                            dangerouslySetInnerHTML={{ __html: docNotes?.provisionalDiagnosis || "-" }} />
                                                    </Box>
                                                </Box>
                                            )}
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else if (item.field_name === 'prescription' && item.is_active) {
                            return (
                                <Box marginTop={'1vw'}>
                                    <Typography fontWeight={'bold'} fontSize={'1vw'}>Prescription</Typography>
                                    <TriggerApiOnView id={`prescription_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`prescription_${id}`} marginTop={'.5vw'}>
                                            <Paper>
                                                <TableContainer>
                                                    <Table size='small' aria-label="stictbl">
                                                        <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                                                            <TableRow>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '10vw' }}>S.No</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '35vw' }}>Drug Name</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '35vw' }}>Dosage Type</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '20vw' }}>Dosage Strength</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {docNotes.prescription.length > 0 ? docNotes.prescription.map((item, i) => {
                                                                return (
                                                                    (isNewOtherDoc ? item.medication : item.prescription_lines)?.length > 0 ?
                                                                        (isNewOtherDoc ? item.medication : item.prescription_lines)?.map((data, index) => (
                                                                        <TableRow>
                                                                            <TableCell sx={{ width: '10vw' }}>{index + 1}</TableCell>
                                                                            <TableCell sx={{ width: '35vw' }}>{data.drug_name || data.brand_name}</TableCell>
                                                                            <TableCell sx={{ width: '35vw' }}>{data.dosage_type}</TableCell>
                                                                            <TableCell sx={{ width: '20vw' }}>{data.drug_strength || data.dosage_strength}</TableCell>
                                                                        </TableRow>
                                                                    )) :
                                                                        <TableRow>
                                                                            <TableCell colSpan={4} align="center">{'No Records To Be Shown'}</TableCell>
                                                                        </TableRow>)
                                                            }) :
                                                                <TableRow>
                                                                    <TableCell colSpan={4} align="center">{'No Records To Be Shown'}</TableCell>
                                                                </TableRow>}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Paper>
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else if (item.field_name === 'plan' && item.is_active) {
                            return (
                                <Box marginTop={'1vw'}>
                                    {!isNewOtherDoc && <Typography fontWeight={'bold'} fontSize={'1vw'}>Plan</Typography>}
                                    <TriggerApiOnView id={`plan_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`plan_${id}`} marginTop={'.5vw'}>
                                            {isNewOtherDoc ?
                                                (<Box display={'flex'}>
                                                    <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                        <Typography fontSize={'1vw'}>{`Plan`}</Typography>
                                                        <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                    </Box>
                                                    <Box width={'50vw'}>
                                                        <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'} dangerouslySetInnerHTML={{ __html: docNotes.plan || "-" }} />
                                                    </Box>
                                                </Box>) :
                                            <Paper>
                                                <TableContainer>
                                                    <Table size='small' aria-label="stictbl">
                                                        <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                                                            <TableRow>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '10vw' }}>S.No</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '17vw' }}>Treatment</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '16vw' }}>Dosage</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '17vw' }}>Route</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '15vw' }}>Procedure</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '15vw' }}>Description</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '10vw' }}>Status</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {docNotes.plan.length > 0 ? docNotes.plan.map((item, i) => (
                                                                <TableRow>
                                                                    <TableCell sx={{ width: '10vw' }}>{i + 1}</TableCell>
                                                                    <TableCell sx={{ width: '17vw' }}>{item.treatment_name}</TableCell>
                                                                    <TableCell sx={{ width: '16vw' }}>{item.dosage}</TableCell>
                                                                    <TableCell sx={{ width: '17vw' }}>{item.route}</TableCell>
                                                                    <TableCell sx={{ width: '15vw' }}>{item.procedure_name}</TableCell>
                                                                    <TableCell sx={{ width: '15vw' }}>{item.description}</TableCell>
                                                                    <TableCell sx={{ width: '10vw' }}>{item.is_completed ? 'Completed' : 'Pending'}</TableCell>
                                                                </TableRow>
                                                            )) :
                                                                <TableRow>
                                                                    <TableCell colSpan={7} align="center">{'No Records To Be Shown'}</TableCell>
                                                                </TableRow>}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Paper>}
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else if (item.field_name === 'general_advice' && item.is_active) {
                            return (
                                <Box marginTop={'1vw'}>
                                    <Typography fontWeight={'bold'} fontSize={'1vw'}>General Advice</Typography>
                                    <TriggerApiOnView id={`genralAdvice_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`genralAdvice_${id}`} marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                            {docNotes.genadvice ?
                                                <Box display={'flex'}>
                                                    <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                        <Typography fontSize={'1vw'}>{`General Advice`}</Typography>
                                                        <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                    </Box>
                                                    <Box width={'50vw'}>
                                                        <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'} dangerouslySetInnerHTML={{ __html: docNotes.genadvice || "-" }}/>
                                                    </Box>
                                                </Box> : null}
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else if (item.field_name === 'counselling' && item.is_active) {
                            return (
                                <Box marginTop={'1vw'}>
                                    <Typography fontWeight={'bold'} fontSize={'1vw'}>Counselling</Typography>
                                    <TriggerApiOnView id={`counselling_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`counselling_${id}`}>
                                            <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                    <Typography fontSize={'1vw'}>{`Surgery`}</Typography>
                                                    <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                </Box>
                                                <Box width={'50vw'}>
                                                    <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{docNotes.counselling.surgery_name || '-'}</Typography>
                                                </Box>
                                            </Box>
                                            <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                    <Typography fontSize={'1vw'}>{`Package Name`}</Typography>
                                                    <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                </Box>
                                                <Box width={'50vw'}>
                                                    <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{docNotes.counselling.package_name || '-'}</Typography>
                                                </Box>
                                            </Box>
                                            <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                    <Typography fontSize={'1vw'}>{`Surgery Time`}</Typography>
                                                    <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                </Box>
                                                <Box width={'50vw'}>
                                                    <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{docNotes.counselling.surgery_time || '-'}</Typography>
                                                </Box>
                                            </Box>
                                            <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                    <Typography fontSize={'1vw'}>{`Surgeon Name`}</Typography>
                                                    <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                </Box>
                                                <Box width={'50vw'}>
                                                    <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{docNotes.counselling.surgeon_name || '-'}</Typography>
                                                </Box>
                                            </Box>
                                            <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                    <Typography fontSize={'1vw'}>{`Anaesthetist`}</Typography>
                                                    <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                </Box>
                                                <Box width={'50vw'}>
                                                    <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{docNotes.counselling.anaesthetist || '-'}</Typography>
                                                </Box>
                                            </Box>
                                            <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                    <Typography fontSize={'1vw'}>{`Counsellor`}</Typography>
                                                    <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                </Box>
                                                <Box width={'50vw'}>
                                                    <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{docNotes.counselling.counsellor_name || '-'}</Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else if (item.field_name === 'review_plan' && item.is_active) {
                            return (
                                <Box marginTop={'1vw'}>
                                    <Typography fontWeight={'bold'} fontSize={'1vw'}>Review Plan</Typography>
                                    <TriggerApiOnView id={`reviewplan_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`reviewplan_${id}`}>
                                            <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                    <Typography fontSize={'1vw'}>{`Duration`}</Typography>
                                                    <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                </Box>
                                                <Box width={'50vw'}>
                                                    <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{(docNotes.reviewPlan.duration && docNotes.reviewPlan.duration_type) ? `${docNotes.reviewPlan.duration || '-'} ${docNotes.reviewPlan.duration_type || ''}` : '-'}</Typography>
                                                </Box>
                                            </Box>
                                            <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                    <Typography fontSize={'1vw'}>{`Review Date & Time`}</Typography>
                                                    <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                </Box>
                                                <Box width={'50vw'}>
                                                    <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>
                                                        {(docNotes.reviewPlan.review_date && docNotes.reviewPlan.appointment_time) ?
                                                            `${formatDate(docNotes.reviewPlan.review_date) || '-'} & 
                                                         ${isNewOtherDoc ? (docNotes.reviewPlan.appointment_time ? DateTime.fromFormat(docNotes.reviewPlan.appointment_time, "HH:mm:ss").toFormat("hh:mm a") : '')
                                                                : (docNotes?.reviewPlan?.appointment_time || "")}` : '-'}</Typography>
                                                </Box>
                                            </Box>
                                            <Box display={'flex'}>
                                                <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                    <Typography fontSize={'1vw'}>{`Comments`}</Typography>
                                                    <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                </Box>
                                                <Box width={'50vw'}>
                                                    <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{docNotes.reviewPlan.comments || '-'}</Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else if (item.field_name === 'clinical_history' && item.is_active) {
                            return(
                                <Box marginTop={'1vw'}>
                                <Typography fontWeight={'bold'} fontSize={'1vw'}>Clinical History</Typography>
                                <TriggerApiOnView id={`clinicalHis_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                    <Box id={`clinicalHis_${id}`} marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                        {Object.keys(docNotes.clinicalHis).length > 0 ?
                                            <Box display={'flex'}>
                                                <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                    <Typography fontSize={'1vw'}>{`Clinical History`}</Typography>
                                                    <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                </Box>
                                                <Box width={'50vw'}>
                                                    <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{docNotes.clinicalHis?.history || '-'}</Typography>
                                                </Box>
                                            </Box> : null}
                                    </Box>
                                </TriggerApiOnView>
                            </Box>
                            )
                        }
                        else if (item.field_name === 'Complaints' && item.is_active) {
                            return (
                                <Box marginTop={'1vw'}> 
                                    {isNewOtherDoc ? null : <Typography fontWeight={'bold'} fontSize={'1vw'}>Complaints</Typography>}
                                    <TriggerApiOnView id={`complaints_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`complaints_${id}`} marginTop={'.5vw'}>
                                            {isNewOtherDoc ? <Box mt={'.5vw'} id={`complaints_${id}`} display={'flex'} flexDirection={'row'}>
                                                <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                    <Typography fontWeight={550} fontSize={'1vw'}>Complaints</Typography>
                                                    <Typography fontSize={'1vw'}>:</Typography>
                                                </Box>
                                                <Box width={'50vw'}>
                                                    <Typography fontSize={'1vw'} fontWeight={'bold'} ml={'1vw'}
                                                        dangerouslySetInnerHTML={{ __html: docNotes?.complaints || "-" }} />
                                                </Box>
                                            </Box> : 
                                            <Paper>
                                                <TableContainer>
                                                    <Table size='small' aria-label="stictbl">
                                                        <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                                                            <TableRow>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '10vw' }}>S.No</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '17vw' }}>Complaints</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '16vw' }}>Duration</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '17vw' }}>Comments</TableCell>

                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {docNotes.complaints.length > 0 ? docNotes.complaints.map((item, i) => (
                                                                <TableRow>
                                                                    <TableCell sx={{ width: '10vw' }}>{i + 1}</TableCell>
                                                                    <TableCell sx={{ width: '17vw' }}>{item.complaint_description}</TableCell>
                                                                    <TableCell sx={{ width: '16vw' }}>{`${item.duration_time} ${item?.duration_type == 1 ? "Days" : item?.duration_type == 2 ? "Weeks" : item?.duration_type == 3 ? "Months" : "Years"}`}</TableCell>
                                                                    <TableCell sx={{ width: '17vw' }}>{item.comments}</TableCell>
                                                                </TableRow>
                                                            )) :
                                                                <TableRow>
                                                                    <TableCell colSpan={4} align="center">{'No Records To Be Shown'}</TableCell>
                                                                </TableRow>}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Paper>}
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else if (item.field_name === "test" && item.is_active) {

                        }
                        else if (item.field_name === 'pain_scale' && item.is_active) {
                            const painLevel = {
                                "(0-1)": { image: ImagePaths.noPainSmile.default, color: "#75B23B", status: "No Pain" },
                                "(1-3)": { image: ImagePaths.noPainSmile.default, color: "#75B23B", status: "Mild Pain" },
                                "(3-4)": { image: ImagePaths.moderateSmile.default, color: "#FFCD05", status: "Moderate" },
                                "(5-7)": { image: ImagePaths.severeSmile.default, color: "#F8981D", status: "Severe" },
                                "(7-9)": { image: ImagePaths.verySevereSmile.default, color: "#F26A22", status: "Very Severe" },
                                "(9-10)": { image: ImagePaths.worstPainsmile.default, color: "#DA1A32", status: "Worst Pain Possible" },
                            };
                            return (
                                <Box marginTop={'1vw'}>
                                    <Typography fontWeight={'bold'} fontSize={'1vw'}>Pain Scale</Typography>
                                    <TriggerApiOnView id={`pain_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`pain_${id}`} marginTop={'.5vw'}>
                                            <Paper>
                                                <TableContainer>
                                                    <Table size='small' aria-label="stictbl">
                                                        <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                                                            <TableRow>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '10vw' }}>S.No</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '40vw' }}>Date & Time</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '50vw' }}>Pain Level</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {docNotes.painChart.length > 0 ? docNotes.painChart.map((item, i) => {
                                                                const painItem = painLevel[item?.pain_level];
                                                                return (
                                                                    <TableRow>
                                                                        <TableCell sx={{ width: '10vw' }}>{i + 1}</TableCell>
                                                                        <TableCell sx={{ width: '40vw' }}>{item.pain_chart_date ? DateTime.fromJSDate(new Date(item.pain_chart_date)).toFormat("dd-MM-yyyy hh:mm a") : "-"}</TableCell>
                                                                        <TableCell sx={{ width: '50vw' }}>
                                                                            <Box component={'div'} sx={{ display: "flex", flexDirection: "row", gap: "0.5vw" }}>
                                                                                <Typography fontSize={'0.9vw'} sx={{ color: painItem.color }}>{item?.pain_level ? item?.pain_level : '-'}</Typography>
                                                                                <img className='emedhub_pain_range' src={painItem.image} />
                                                                                <Typography fontSize={'0.9vw'} sx={{ color: painItem.color }}>{painItem.status}</Typography>
                                                                            </Box>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            }) :
                                                                <TableRow>
                                                                    <TableCell colSpan={3} align="center">{'No Records To Be Shown'}</TableCell>
                                                                </TableRow>}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Paper>
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else if (item.field_name === 'past_history' && item.is_active) {
                            return (
                                <Box marginTop={'1vw'}>
                                    <Typography fontWeight={'bold'} fontSize={'1vw'}>Past History</Typography>
                                    <TriggerApiOnView id={`past_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`past_${id}`} marginTop={'.5vw'}>
                                            <Paper>
                                                <TableContainer>
                                                    <Table size='small' aria-label="stictbl">
                                                        <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                                                            <TableRow>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '10vw' }}>S.No</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '40vw' }}>History</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '50vw' }}>Duration</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {docNotes?.pastHis.length > 0 ? docNotes?.pastHis?.map((item, i) => {
                                                                return (
                                                                    <TableRow>
                                                                        <TableCell sx={{ width: '10vw' }}>{i + 1}</TableCell>
                                                                        <TableCell sx={{ width: '40vw' }}>{item.past_history}</TableCell>
                                                                        <TableCell sx={{ width: '50vw' }}>{`${item.duration} ${item.duration_mode}`}</TableCell>
                                                                    </TableRow>
                                                                )
                                                            }) :
                                                                <TableRow>
                                                                    <TableCell colSpan={3} align="center">{'No Records To Be Shown'}</TableCell>
                                                                </TableRow>}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Paper>
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else if (item.field_name === 'final_diagnosis' && item.is_active) {
                            return (
                                <Box marginTop={'1vw'}>
                                    {isNewOtherDoc ? null : <Typography fontWeight={'bold'} fontSize={'1vw'}>Final Diagnosis</Typography>}
                                    <TriggerApiOnView id={`finalDig_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`finalDig_${id}`}>
                                            {isNewOtherDoc ? <Box mt={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                    <Typography fontWeight={550} fontSize={'1vw'}>Final Diagnosis</Typography>
                                                    <Typography fontSize={'1vw'}>:</Typography>
                                                </Box>
                                                <Box width={'50vw'}>
                                                    <Typography fontSize={'1vw'} fontWeight={'bold'} ml={'1vw'}
                                                        dangerouslySetInnerHTML={{ __html: docNotes?.finalDig || "-" }} />
                                                </Box>
                                            </Box> :
                                            (docNotes.finalDig.length > 0 ? docNotes.finalDig.map((item, o) => (
                                                <Box>
                                                    <Typography fontSize={'.9vw'} fontWeight={'bold'} color={'#616161'}>{`Diagnosis ${o + 1}`}</Typography>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`ICD Code`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.icd_code || '-'}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`Short Description`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.short_desc || '-'}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{`Long Description`}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.desc || '-'}</Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            )) : null)}
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else if (item.field_name === "obstetric_data" && item.is_active) {
                            return (
                                <Box marginTop={'1vw'}>
                                    <Typography fontWeight={'bold'} fontSize={'1vw'}>Obstetric Data</Typography>
                                    <TriggerApiOnView id={`obsData_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`obsData_${id}`}>
                                            <Box>
                                                <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                                    <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                        <Typography fontSize={'1vw'}>{`PICME`}</Typography>
                                                        <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                    </Box>
                                                    <Box width={'50vw'}>
                                                        <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{docNotes?.obstric?.picme || '-'}</Typography>
                                                    </Box>
                                                </Box>
                                                <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                    <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                        <Typography fontSize={'1vw'}>{`Gravida`}</Typography>
                                                        <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                    </Box>
                                                    <Box width={'50vw'}>
                                                        <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{docNotes?.obstric?.gravida || '-'}</Typography>
                                                    </Box>
                                                </Box>
                                                <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                    <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                        <Typography fontSize={'1vw'}>{`Para`}</Typography>
                                                        <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                    </Box>
                                                    <Box width={'50vw'}>
                                                        <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{docNotes?.obstric?.para || '-'}</Typography>
                                                    </Box>
                                                </Box>
                                                <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                    <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                        <Typography fontSize={'1vw'}>{`Live Birth`}</Typography>
                                                        <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                    </Box>
                                                    <Box width={'50vw'}>
                                                        <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{docNotes?.obstric?.live_births || '-'}</Typography>
                                                    </Box>
                                                </Box>
                                                <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                                    <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                        <Typography fontSize={'1vw'}>{`Abortion`}</Typography>
                                                        <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                    </Box>
                                                    <Box width={'50vw'}>
                                                        <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{docNotes?.obstric?.abortions || '-'}</Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else if (item.field_name === 'history_of_presenting_illness' && item.is_active) {
                            return (
                                <Box marginTop={'1vw'}> 
                                    {isNewOtherDoc ? null : <Typography fontWeight={'bold'} fontSize={'1vw'}>History of Presenting Illness</Typography>}
                                    <TriggerApiOnView id={`history_of_presenting_illness_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                                        <Box id={`history_of_presenting_illness_${id}`} marginTop={'.5vw'}>
                                            {isNewOtherDoc ? <Box mt={'.5vw'} id={`complaints_${id}`} display={'flex'} flexDirection={'row'}>
                                                <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                    <Typography fontWeight={550} fontSize={'1vw'}>History of Presenting Illness</Typography>
                                                    <Typography fontSize={'1vw'}>:</Typography>
                                                </Box>
                                                <Box width={'50vw'}>
                                                    <Typography fontSize={'1vw'} fontWeight={'bold'} ml={'1vw'}
                                                        dangerouslySetInnerHTML={{ __html: docNotes?.history_of_presenting_illness || "-" }} />
                                                </Box>
                                            </Box> : 
                                            <Paper>
                                                <TableContainer>
                                                    <Table size='small' aria-label="stictbl">
                                                        <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                                                            <TableRow>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '10vw' }}>S.No</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '17vw' }}>Presenting Illness</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '16vw' }}>Duration</TableCell>
                                                                <TableCell sx={{ fontWeight: 'bold', width: '17vw' }}>Comments</TableCell>

                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {docNotes.history_of_presenting_illness.length > 0 ? docNotes.history_of_presenting_illness.map((item, i) => (
                                                                <TableRow>
                                                                    <TableCell sx={{ width: '10vw' }}>{i + 1}</TableCell>
                                                                    <TableCell sx={{ width: '17vw' }}>{item.illness}</TableCell>
                                                                    <TableCell sx={{ width: '16vw' }}>{`${item.duration_time} ${item?.duration_type == 1 ? "Days" : item?.duration_type == 2 ? "Weeks" : item?.duration_type == 3 ? "Months" : "Years"}`}</TableCell>
                                                                    <TableCell sx={{ width: '17vw' }}>{item.comments}</TableCell>
                                                                </TableRow>
                                                            )) :
                                                                <TableRow>
                                                                    <TableCell colSpan={4} align="center">{'No Records To Be Shown'}</TableCell>
                                                                </TableRow>}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Paper>}
                                        </Box>
                                    </TriggerApiOnView>
                                </Box>
                            )
                        }
                        else {
                            if (item.is_active) {
                                let name = item.custom_name
                                return (
                                    <Box marginTop={'1vw'}>
                                        <Typography fontWeight={'bold'} fontSize={'1vw'}>{name}</Typography>
                                        <TriggerApiOnView id={`${name}_${id}`} onEnterView={(id) => getNoteData(id, item.label)} isProgrammaticScroll={isProgrammaticScroll} >
                                            <Box id={`${name}_${id}`} marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'flex-start'} flexWrap="wrap">
                                                {Object.keys(docNotes[item.label] || {}).length > 0 ?
                                                    <Box display={'flex'}>
                                                        <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                            <Typography fontSize={'1vw'}>{name}</Typography>
                                                            <Typography fontSize={'1vw'}>{`:`}</Typography>
                                                        </Box>
                                                        <Box width={'50vw'}>
                                                            <Typography fontSize={'1vw'} fontWeight={'bold'} ml={'1vw'}
                                                                sx={{
                                                                    whiteSpace: 'normal',
                                                                    wordBreak: 'break-word',
                                                                    overflowWrap: 'anywhere',
                                                                }}
                                                                dangerouslySetInnerHTML={{ __html: docNotes[item.label]?.comments || '-' }} />
                                                        </Box>
                                                    </Box> : null}
                                            </Box>
                                        </TriggerApiOnView>
                                    </Box>
                                )
                            }
                        }
                    }) :
                        <Box >
                            <Typography color={'#888888'}>{'Doctor Notes Not Available'}</Typography>
                        </Box>}
                </Box> :
                <Box>
                    <Box marginTop={'1vw'}>
                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Symptoms</Typography>
                        <TriggerApiOnView id={`symptomsIP_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                            <Box id={`symptomsIP_${id}`}>
                                {docNotes.IP_symptom.length > 0 ? docNotes.IP_symptom.map((item, i) => (
                                    <Box>
                                        <Typography fontSize={'.9vw'} fontWeight={'bold'} color={'#616161'}>{`Symptom ${i + 1}`}</Typography>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Doctor Name`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.doctor_name || '-'}</Typography>
                                            </Box>
                                        </Box>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Symptom Name`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.symptoms_name || '-'}</Typography>
                                            </Box>
                                        </Box>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Duration`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{`${item.duration} ${item.duration_type}`}</Typography>
                                            </Box>
                                        </Box>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Description`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.description || '-'}</Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                )) : null}
                            </Box>
                        </TriggerApiOnView>
                    </Box>
                    <Box marginTop={'1vw'}>
                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Examination</Typography>
                        <TriggerApiOnView id={`examinationIP_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                            <Box id={`examinationIP_${id}`}>
                                {docNotes.IP_examination.length > 0 ? docNotes.IP_examination.map((item, i) => (
                                    <Box>
                                        <Typography fontSize={'.9vw'} fontWeight={'bold'} color={'#616161'}>{`Symptom ${i + 1}`}</Typography>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Doctor Name`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.doctor_name || '-'}</Typography>
                                            </Box>
                                        </Box>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Examination Name`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.exam_name || '-'}</Typography>
                                            </Box>
                                        </Box>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Description`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.description || '-'}</Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                )) : null}
                            </Box>
                        </TriggerApiOnView>
                    </Box>
                    <Box marginTop={'1vw'}>
                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Provisional Diagnosis</Typography>
                        <TriggerApiOnView id={`proviDiagIP_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                            <Box id={`proviDiagIP_${id}`}>
                                {docNotes.IP_proviDig.length > 0 ? docNotes.IP_proviDig.map((item, i) => (
                                    <Box>
                                        <Typography >{item.notes || '-'}</Typography>
                                    </Box>
                                )) : null}
                            </Box>
                        </TriggerApiOnView>
                    </Box>
                    <Box marginTop={'1vw'}>
                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Diagnosis</Typography>
                        <TriggerApiOnView id={`diagnosisIP_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                            <Box id={`diagnosisIP_${id}`}>
                                {docNotes.IP_Dignosis.length > 0 ? docNotes.IP_Dignosis.map((item, o) => (
                                    <Box>
                                        <Typography fontSize={'.9vw'} fontWeight={'bold'} color={'#616161'}>{`Diagnosis ${o + 1}`}</Typography>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Doctor Name`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.doctor_name || '-'}</Typography>
                                            </Box>
                                        </Box>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`ICD Code`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.icd_code || '-'}</Typography>
                                            </Box>
                                        </Box>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Short Description`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.icd_short_desc || '-'}</Typography>
                                            </Box>
                                        </Box>
                                        <Box marginTop={'.5vw'} display={'flex'} flexDirection={'row'}>
                                            <Box display={'flex'} width={'20vw'} justifyContent={'space-between'}>
                                                <Typography fontSize={'1vw'}>{`Long Description`}</Typography>
                                                <Typography fontSize={'1vw'}>{`:`}</Typography>
                                            </Box>
                                            <Box width={'50vw'}>
                                                <Typography fontSize={'1vw'} fontWeight={'bold'} marginLeft={'1vw'}>{item.icd_desc || '-'}</Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                )) : null}
                            </Box>
                        </TriggerApiOnView>
                    </Box>
                    <Box marginTop={'1vw'}>
                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Discharge Notes</Typography>
                        <TriggerApiOnView id={`disNoteIP_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                            <Box id={`disNoteIP_${id}`}>
                                {docNotes.IP_notes.length > 0 ? docNotes.IP_notes.map((item, i) => (
                                    <Box>
                                        <Typography >{item.discharge_notes || '-'}</Typography>
                                    </Box>
                                )) : null}
                            </Box>
                        </TriggerApiOnView>
                    </Box>
                    <Box marginTop={'1vw'}>
                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Family Counselling</Typography>
                        <TriggerApiOnView id={`FamilyCounIP_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                            <Box id={`FamilyCounIP_${id}`}>
                                {docNotes.IP_notes.length > 0 ? docNotes.IP_notes.map((item, i) => (
                                    <Box>
                                        <Typography >{item.family_counselling || '-'}</Typography>
                                    </Box>
                                )) : null}
                            </Box>
                        </TriggerApiOnView>
                    </Box>
                    <Box marginTop={'1vw'}>
                        <Typography fontWeight={'bold'} fontSize={'1vw'}>Medication & Instructions</Typography>
                        <TriggerApiOnView id={`medicationIP_${id}`} onEnterView={(id) => getNoteData(id)} isProgrammaticScroll={isProgrammaticScroll} >
                            <Box id={`medicationIP_${id}`}>
                                {docNotes.IP_notes.length > 0 ? docNotes.IP_notes.map((item, i) => (
                                    <Box>
                                        <Typography >{item.instructions || '-'}</Typography>
                                    </Box>
                                )) : null}
                            </Box>
                        </TriggerApiOnView>
                    </Box>
                </Box>}
            {errorMsg && <ToastMsg
                severity={'error'}
                msg={errorMsgText}
                msgPop={msgClose.bind(this)}
            />}
        </Box>
    )
}